export const APP_TITLE = "Performance Intelligence Academy"

/**
 * Builds a document title for a page
 * @param {*} page: page-specific title, e.g. "10DWC Dashboard"
 * @returns "Performance Intelligence Academy | 10DWC Dashboard", or the bare app
 *          name when no page is given
 */
export const pageTitle = page => (page ? `${APP_TITLE} | ${page}` : APP_TITLE)

export const convertSnakeToTitle = str => str
.split("_")
.filter(x => x.length > 0)
.map(x => (x.charAt(0).toUpperCase() + x.slice(1)))
.join(" ")

export const calculatorTypeLabel = (type, version) => {
  if (!type) return "—"
  if (type !== "live_life") return convertSnakeToTitle(type)
  return String(version) === "1" ? "LiveLife Score" : "PQ Index"
}

/**
 * Checks if any string elements in array are duplicated
 * @param {*} arr: array of strings
 * @returns true or false
 */
export const checkIfDuplicatesInArray = arr => {
  const unique = arr.filter((item, index) => arr.indexOf(item) === index)
  return unique.length !== arr.length
}

export const apiErrorMessage = (err, fallback = "Something went wrong. Please try again.") => {
  const [firstError] = err?.response?.data?.errors || []
  return firstError?.detail || firstError?.title || err?.message || fallback
}

export const invalidNumberKeys = (integerOnly = false) => (
  integerOnly ? ["e", "E", "+", "-", ".", ","] : ["e", "E", "+", "-"]
)

export const roundToInteger = value => {
  if (value === "" || value === null || value === undefined) return value
  const numeric = Number(value)
  return Number.isNaN(numeric) ? value : String(Math.round(numeric))
}
